import { z } from 'zod';
import { TFunction } from 'i18next';

export const createRejectServiceRequestSchema = (t: TFunction) =>
  z.object({
    rejectReason: z.string().min(1, t('cmrlist.reject.validation.reasonRequired', 'Please select a reason')),
    rejectComment: z.string().min(1, t('cmrlist.reject.validation.commentRequired', 'Please provide a comment'))
  });

export type RejectServiceRequestFormValues = z.infer<ReturnType<typeof createRejectServiceRequestSchema>>;

export const DEFAULT_REJECT_VALUES: RejectServiceRequestFormValues = {
  rejectReason: '',
  rejectComment: ''
};
